import { useState, useEffect, useContext } from "react"
import AuthContext from "contexte/AuthContext"
import { useTranslation } from "react-i18next"
import "./leverageVolumePerStock.css"
import DashboardLayout from "components/layout/dashboard/DashboardLayout"
import FilterComponent from "components/Filters/FilterComponent/FilterComponent"
import PageLoader from "components/pageLoader/PageLoader"
import Tableau from "components/DataComponents/Tableau/Tableau"
import { RELEASE_DATE } from 'utils/date';
import { fetchReportLeverageVolumePerStock } from "services/fetchTradeReports"
import { formatNumberWithSpaces } from "utils/numbers"
import Notification from "components/notifications/Notification"
import { launchError } from "components/notifications"

const LeverageVolumePerStock = () => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();

  const [volumes, setVolumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const fetchData = async () => {
    try {
      const endDate = selectedDate.date1?.endDate;
      const startDate = selectedDate.date1?.startDate;
      const data = await fetchReportLeverageVolumePerStock({ user, startDate, endDate, limit, page });
      setVolumes(data);
    } catch (e) {
      launchError(t('notifications.global.errors.fetch'))
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData()
  }, [page, limit, selectedDate.date1?.startDate, selectedDate?.date1?.endDate]
  );

  const transformDataToTbody = (data) => {

    return data.map(item => {
      return {
        data: [
          item.ticker,
          formatNumberWithSpaces(Number(item.total_volume)),
          formatNumberWithSpaces(Number(item.long_volume)),
          formatNumberWithSpaces(Number(item.short_volume)),
        ]
      };
    });
  }

  return (
    <DashboardLayout page={t("pages_name.report_users")}>
      <Notification />
      <div>
        {
          !loading ? (
            <div>
              <div className="flexbox">
                <h3>Volume par action (leverage)</h3>
                <FilterComponent
                  page={true}
                  limit={true}
                  date
                  fetchLimit={limit} setFetchLimit={setLimit}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </div>
              <div>
                <Tableau
                  thead={['Ticker', 'Volume Total', 'Long', 'Short']}
                  tbody={transformDataToTbody(volumes)}
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  pagination={true}
                />
              </div>
            </div>
          ) : (
            <div className='pageLoaderBox'>
              <PageLoader />
            </div>
          )
        }
      </div>
    </DashboardLayout>
  )
}

export default LeverageVolumePerStock